import { Actions } from "./actions";
import {
  DELETE_DOCUMENT_SIGNATURE_RESPONSE,
  DOCUMENT_SIGNATURE_BY_FIELD_LIST,
  DOCUMENT_SIGNATURE_BY_ID,
  DOCUMENT_SIGNATURE_LIST,
  REFRESH_SIGNATURE_STATUS,
  REFRESH_SIGNATURE_STATUS_RESPONSE,
  RESEND_DOCUMENT_SIGNATURE_RESPONSE,
  SAVE_DOCUMENT_SIGNATURE_RESPONSE,
  UPDATE_DOCUMENT_SIGNATURE_RESPONSE,
} from "./actionTypes";
import { DocumentSignatureState, initialState } from "./state";

export function DocumentSignatureReducer(
  state = initialState,
  action: Actions
): DocumentSignatureState {
  switch (action.type) {
    case DOCUMENT_SIGNATURE_LIST:
      return Object.assign({}, state, {
        documentSignatureList: action.payload,
      });
    case DOCUMENT_SIGNATURE_BY_ID:
      return Object.assign({}, state, {
        documentSignatureById: action.payload,
      });
    case SAVE_DOCUMENT_SIGNATURE_RESPONSE:
      return Object.assign({}, state, {
        saveDocumentSignatureResp: action.payload,
      });
    case UPDATE_DOCUMENT_SIGNATURE_RESPONSE:
      return Object.assign({}, state, {
        updateDocumentSignatureResp: action.payload,
      });
    case DELETE_DOCUMENT_SIGNATURE_RESPONSE:
      return Object.assign({}, state, {
        deleteDocumentSignatureResp: action.payload,
      });
    case DOCUMENT_SIGNATURE_BY_FIELD_LIST:
      return Object.assign({}, state, {
        documentSignatureByFieldList: action.payload,
      });
    case RESEND_DOCUMENT_SIGNATURE_RESPONSE:
      return Object.assign({}, state, {
        resendDocumentSignatureResp: action.payload,
      });
    case REFRESH_SIGNATURE_STATUS_RESPONSE:
      return Object.assign({}, state, {
        refreshSignatureStatus: action.payload,
      });
    default:
      return state;
  }
}
